<div class="text-justify">
	<p>This privacy policy (“Policy”) applies to the website(s) and mobile application(s) (hereinafter referred to as,
		the "Sites") provided by Moniepoint Microfinance Bank Limited (“Moniepoint MFB”, “we”, “us”, “our”) , and other
		products/services of Moniepoint MFB . This Policy discloses our data protection practices on our Sites, products
		and subscriber-based services (“Services”), inclusive of the type of personal data that we collect, our method
		of collection of personal data, use of personal data and procedures for sharing personal data with third
		parties.</p>
	<p>The Sites covered by this Policy include our existing websites, mobile applications and all other additional
		websites and mobile applications produced and managed by Moniepoint MFB. Details of existing Sites include the
		following:</p>
	<ul>
		<li>Moniepoint MFB- <a href="http://www.moniepoint.com/ng">www.moniepoint.com/ng</a>;</li>
		<li>Moniepoint MFB- <a href="www.atm.moniepoint.com/login/web">www.atm.moniepoint.com/login/web</a></li>
	</ul>
	<p>We are committed to protecting your personal data (i.e. any information you provide to us through which you can
		be identified) in accordance with the provisions of the Nigeria Data Protection Act 2023 and other applicable
		data protection laws (“Data Protection Laws”).</p>
	<p>By visiting the Sites (including all websites and mobile applications which may be added or removed from time to
		time) you agree to this Privacy Policy. By continuing to visit our website and use our services you accept and
		consent to the practices contained in our privacy policy.</p>
	<h3>LAWFUL BASIS FOR COLLECTING AND PROCESSING PERSONAL DATA</h3>
	<p>In compliance with the provisions of Data Protection Laws, we process your personal data in line with the
		following legal basis:&nbsp;</p>
	<ul>
		<li><strong>Consent:&nbsp;</strong>where you have consented to our processing of your personal data for one or
			more specific reasons. Such consent is given by you through your continuous use of the Services and the
			Sites.</li>
		<li><strong>Performance of a contract:&nbsp;</strong>in order to perform a contract we have with you or a
			contract to which you are a party to and in order to take necessary steps at your request prior to entering
			into such a contract.</li>
		<li><strong>Legal obligation:</strong>&nbsp;where processing of personal data is required by law. We are
			required by law to retain certain account opening information and personal data of our customers beyond the
			date such customers cease to carry on business with us.</li>
		<li><strong>Legitimate&nbsp;interest:</strong>&nbsp;in order to protect legitimate interests of data subjects,
			and in order to carry out the purposes of our business, such as account opening, and processing financial
			transactions. In addition to this, we have a legitimate interest to prevent fraud, money laundering and to
			verify identity of data subjects, in order to protect our customers and business, to understand how people
			interact with our Sites, to provide communication which we think will be of interest to you and to determine
			the effectiveness of promotional campaigns and advertising.</li>
		<li><strong>Vital interest:</strong> in order to process data for data subjects when they are in critical life
			threatening situations where they may not be able to provide consent for data processing, and which may be
			vital for the subjects survival.</li>
		<li><strong>Public interest:</strong> such processing is necessary for the performance of a task carried out in
			the interest of the public on in exercise of an official public mandate vested on us.</li>
	</ul>
	<h3>INFORMATION WE MAY COLLECT FROM YOU</h3>
	<p>When you use the Sites or Services, we collect and store your personal data which is provided by you from time to
		time.&nbsp;</p>
	<p>Personal data/ information in this context shall include all data such as: any means of information relating to
		an identified or identifiable natural person who can be identified by:</p>
	<ul>
		<li>a name;</li>
		<li>an identification number;</li>
		<li>location data, an online identifier;</li>
		<li>address, a photo, an email address;</li>
		<li>facial recognition data;</li>
		<li>bank details;</li>
		<li>posts on social networking websites; and</li>
		<li>other unique identifiers such as but not limited to MAC address, IP address, IMEI number, IMSI number, SIM.
		</li>
	</ul>
	<p>For the purpose of accessing our Services, the personal data we may collect include: your full legal names,
		marital status, title, date of birth, gender, photo, facial recognition data, business name, email address,
		mailing address, telephone number, bank account number, payment card details, bank verification number, national
		identification number, international passport number, means of identification, guarantors contact details, bank
		statements, usernames, password, your preferences, interests, feedback and survey responses, preference in
		receiving marketing information from us and our third parties and your communication preferences, etc.&nbsp;</p>
	<p>Our primary goal in collecting the above stated personal data is to provide you with a safe, efficient, smooth
		and customised experience. This allows us to provide services and features that most likely meet your needs.
		&nbsp;</p>
	<h3>HOW WE COLLECT INFORMATION</h3>
	<p>We collect information you provide directly to us, for example, we collect information when you register or log
		on to the Sites, create an account, subscribe to a Service, participate in any interactive features on our
		Services, fill out a form, take part in surveys, post on our message boards, upload any documentation, request
		customer support, make an enquiry, communicate with us by email, phone or post, interact with us on social
		media, etc.</p>
	<p>We will also collect your information where you partially complete and/or abandon any information inputted in the
		Sites and may use this information to contact you to remind you to complete any outstanding information.</p>
	<p>Every computer connected to the internet is given a domain name and a set of numbers that serve as that
		computer’s internet protocol “IP address”. When you use the Sites, our web servers automatically recognize your
		domain name and IP address. The domain name and IP address reveals nothing personal about you other than the IP
		address from which you have accessed the Sites. We are able to see information relating to your browsing
		patterns and technical data about the equipment you use to access the website through the use of cookies, server
		logs and other similar technologies. You can select your preference from the cookies settings on any of our
		websites.&nbsp;</p>
	<p>We may also collect technical data from third parties/ public sources such as analytics providers, identity
		verification providers, advertising networks, search information providers. We may obtain contact, financial and
		transaction data from providers of technical, payment, credit referencing and delivery services based both
		inside and outside Nigeria. We utilise third-party service providers to secure information related to financial
		crime, fraud, sanctions and politically exposed persons.</p>
	<p>We do not own personal data provided and will only store such data for a period reasonably needed and we will do
		our best to ensure that such personal data is secured against all foreseeable hazards and breaches such as
		theft, cyber-attack, viral attack, unauthorised dissemination, manipulation of any kind, damage by rain, fire or
		exposure to other natural elements.&nbsp;</p>
	<p>We will not sell, share, transfer or rent out any personal information to others in ways different from what is
		disclosed in this Policy, and our terms and conditions of use. We may share generic information not linked to
		any personal identification information regarding visitors and users with our business partners, trusted
		affiliates and advertisers.</p>
	<h3>INFORMATION WE COLLECT FROM OTHER SOURCES</h3>
	<p>In order to provide you with access to the Services, or to provide you with better service in general, we may
		combine information obtained from other sources (for example, a third-party developer whose application you have
		authorised) and combine that with information we collect through the Sites.</p>
	<h3>HOW WE USE YOUR PERSONAL DATA</h3>
	<p>The purpose of collecting your personal data is to give you an efficient, enjoyable, secure and seamless customer
		experience. &nbsp;</p>
	<p>We may use your personal data based on your consent for the following purposes:</p>
	<ul>
		<li>To respond to your enquiries and fulfil any of your requests for information;</li>
		<li>To process transactions and send notices about your transactions to requisite parties;</li>
		<li>To verify your identity;&nbsp;</li>
		<li>To resolve disputes and troubleshoot problems;</li>
		<li>To improve our services by implementing aggregate customer preferences;</li>
		<li>To manage and protect our information technology infrastructure;</li>
		<li>To monitor traffic patterns and usage of the Sites to help to improve the Sites design and layout;</li>
		<li>To record and store communications made via phone, skype or the website chat function;</li>
		<li>To personalise your experience on our Sites or communications/advertising;</li>
		<li>To send you important information regarding the services and/or other technical notices, updates, security
			alerts, support and administrative messages;</li>
		<li>To poll your opinions through surveys or questionnaires; and</li>
		<li>As Moniepoint MFB believes to be necessary or appropriate:</li>
		<ul>
			<li>To comply with a legal obligation. This applies where the processing is necessary for Moniepoint MFB to
				comply with the law;</li>
			<li>To protect Moniepoint MFB’s legitimate interests, privacy, property or safety, and/or those of a third
				party as long as your rights do not override those interests.</li>
			<li>To protect your vital interests</li>
		</ul>
	</ul>
	<p>We may monitor and record our communications with you, including e-mails and phone conversations for training,
		quality assurance purposes, and to meet our legal and regulatory obligations in general.&nbsp;</p>
	<p>Whenever we use your information for our legitimate interests, we will ensure that your information is processed
		on an anonymised basis and displayed at aggregated levels, which will not be linked back to you or to any living
		individual.</p>
	<h3>YOUR RIGHTS AS A DATA SUBJECT</h3>
	<p>Your personal data is protected by legal rights enshrined in Data Protection Laws. These rights include the
		following:</p>
	<ul>
		<li>Right to be informed i.e. confirmation as to whether the data controller or a data processor operating on
			its behalf, is storing or otherwise processing personal data relating to the data subject;</li>
		<li>Right to request a copy of data subject’s personal data in a commonly used electronic format, except to the
			extent that providing such data would impose unreasonable costs on the data controller, in which case the
			data subject may be required by the controller to bear some or all of the costs;</li>
		<li>Right to have correction or, if correction is not feasible or suitable, deletion of the data subject’s
			personal data that is inaccurate, out of date, incomplete, or misleading;</li>
		<li>Right for erasure of personal data concerning the data subject, without undue delay;</li>
		<li>Right to withdraw, at any time, consent to the processing of personal data under the Nigeria Data Protection
			Act 2023;</li>
		<li>Right to object to the processing of personal data concerning the data subject;</li>
		<li>Right to object to any decisions based on the automated processing of your personal data, including
			profiling;</li>
		<li>Right to data portability;</li>
		<li>Right to lodge a complaint with the Nigeria Data Protection Commission (NDPC).</li>
	</ul>
	<p>Please note that if you request for a copy of your personal data, you may be required to pay a fee if the
		requests are considered manifestly unfounded or excessive.</p>
	<p>If you would like to exercise any of the above stated rights, please follow the following procedures:&nbsp;</p>
	<ul>
		<li>put your request in writing and send it to us through your usual registered channel (e.g. by registered
			email) and specify the right you wish to exercise.</li>
		<li>You can also access the Data Subject Access Request (DSAR) portal on our website.</li>
	</ul>
	<p>For more information or to exercise your data protection rights please, please contact our Data Protection
		Officer at&nbsp;<a href="mailto:dpo@teamapt.com">dpo@moniepoint.com</a>.</p>
	<p>We will endeavour to process all subject access requests within thirty (30) days and if any further extension is
		required, we will communicate same through existing consented channels – at no cost. However, please note that
		you may continue to receive existing communications for a transitional period whilst we update your preferences.
	</p>
	<h3>RETENTION OF YOUR DATA</h3>
	<p>We will not retain your personal data for longer than is necessary for the purposes for which such personal data
		is processed. This means that your personal data will only be retained for as long as it is still required to
		provide you with the Services or is necessary for legal reasons. When calculating the appropriate retention
		period of your personal data we consider the nature and sensitivity of the personal data, the purposes for which
		we are processing such personal data, and any applicable statutory/regulatory retention periods. Using these
		criteria, we regularly review the personal data that we hold and the purposes for which such is held and
		processed. Our Payment Card Industry Data Security Standard (“PCIDSS”) obligation means that we are obliged to
		retain personal data for a minimum of ten (10) years from the end date of our business relationship with
		you.&nbsp;</p>
	<p>When we determine that personal data can no longer be retained (or where you request that we delete your personal
		data in accordance with your rights contained in Data Protection Laws) we ensure that such personal data is
		securely deleted, anonymised or destroyed.</p>
	<p>Please see details of our data retention and disposal process below:&nbsp;</p>
	<table>
		<tbody>
			<tr>
				<td>
					<h3>Type of data</h3>
				</td>
				<td>
					<h3>Retention Period</h3>
				</td>
				<td>
					<h3>Disposal Process</h3>
				</td>
			</tr>
			<tr>
				<td>
					<p>Electronic storage on database&nbsp;</p>
				</td>
				<td>
					<p>10 years</p>
					<p>(regulatory reasons)</p>
				</td>
				<td>
					<p><em>Programmatic (automatic) process to remove, at least on a quarterly basis, personal data that
							exceeds business retention requirements/reviews conducted at least on a quarterly basis</em>
					</p>
				</td>
			</tr>
			<tr>
				<td>
					<p>Hardcopy data (receipts/faxes)</p>
				</td>
				<td>
					<p>10 years</p>
				</td>
				<td>
					<p><em>Cross-cut shredded/incinerated, pulped</em></p>
				</td>
			</tr>
			<tr>
				<td>
					<p>Hard drives (back-up)</p>
				</td>
				<td>
					<p>10 years&nbsp;</p>
				</td>
				<td>
					<p><em>Secure wipe program/degauss</em></p>
				</td>
			</tr>
			<tr>
				<td>
					<p>Tape Media (back-up)</p>
				</td>
				<td>
					<p>10 years&nbsp;</p>
				</td>
				<td>
					<p>Physically destroy</p>
				</td>
			</tr>
			<tr>
				<td>
					<p>System and network logs</p>
				</td>
				<td>
					<ol>
						<li>1 year&nbsp;</li>
					</ol>
				</td>
			</tr>
		</tbody>
	</table>
	<p>On at least a quarterly basis, we systematically remove and destroy all cardholder data that has exceeded its
		retention period, and review and ensure the remaining stored cardholder data remains within the formal retention
		requirements.&nbsp;</p>
	<p>Wherever the primary account number (“PAN”) is stored, whether electronically or on paper, it is masked. The
		first six and last four digits are the maximum number of digits that may be displayed. Certain members of the
		operations and Service delivery units have a legitimate business need when dealing with customer/cardholder
		enquiries to access the PAN. Wherever the PAN is stored (including in logs, removable media, etc.), it is made
		unreadable by means of one-way hashes.&nbsp;Cardholder data is never stored on removable media and when
		removable physical storage media (including documents, faxes, and electronic media) are no longer required (i.e.
		they have passed their retention periods), they are destroyed.&nbsp;</p>
	<p><br><br><br></p>
	<h3>ACCURACY OF YOUR DATA</h3>
	<p>It is important that the personal data Moniepoint MFB holds about you is accurate and current. Please keep
		Moniepoint MFB informed if any aspect of your personal data changes at any time during your relationship with
		us. On our customer facing products, you can easily update your personal data yourself or alternatively contact
		our Data Protection Officer via <a href="mailto:dpo@teamapt.com">dpo@moniepoint.com</a> when you want to
		exercise your right of rectification.</p>
	<h3>SECURITY OF YOUR DATA</h3>
	<p>In order to protect your personal data, we have put in place appropriate organisational and technical security
		measures. These measures include storing data on a dedicated and secure server with at least 256-bit encryption,
		restricting access to your personal data to certain employees, ensuring that our internal information technology
		systems are suitably secure, and implementing procedures to deal with any suspected data breach.</p>
	<p>In the unlikely event of a data breach, Moniepoint MFB will take steps to mitigate any loss or destruction of
		data and, if appropriate, will notify you and any applicable authority of such a breach.</p>
	<p>We will keep your information secure by taking appropriate technical and organisational measures against its
		unauthorised or unlawful processing and against its accidental loss, destruction or damage. We will do our best
		to protect your personal data, but we cannot guarantee the security of your personal data which is transmitted
		to other websites via an internet or similar connection. If we have given you (or you have chosen) a password to
		access certain areas of the Sites please keep this password safe, we will not share this password with anyone.
	</p>
	<p>As a user of the Services, you understand and agree that you assume all responsibility and risk attached to
		safeguarding your account with us. You shall at no time whatsoever disclose your password to anyone, nor shall
		you allow anyone make use of your account.</p>
	<h3>DATA TRANSFERS AND SHARING</h3>
	<p>Due to the fact that we operate in a regulated environment, we cannot ensure that all your private communications
		and other personally identifiable information will never be disclosed in ways not otherwise described in this
		Policy. By way of example (without limiting the foregoing), we may be required to disclose information to the
		government, regulatory bodies, law enforcement agencies, and third parties for the performance of a task carried
		out in the interest of the public interest.</p>
	<p>We may need to pass your information to third party service providers which maintain, administer or develop the
		Sites on our behalf and the information will only be provided for such limited purposes and as detailed below.
		Additionally, we may provide aggregate statistics about our customers, sales, traffic patterns and related
		website information to reputable third-parties, but these statistics will include no personally identifiable
		information.</p>
	<p>Moniepoint MFB may transfer your personal data to third parties (“Third Party Providers”) of the following types:
	</p>
	<ul>
		<li>companies providing identity or financial validation services;</li>
		<li>financial product providers;</li>
		<li>payment services companies acting on your, or our behalf;</li>
		<li>banks;</li>
		<li>companies providing analytics services;</li>
		<li>data, service and software providers;</li>
		<li>Regulatory and law enforcement bodies.</li>
	</ul>
	<p>A few of our identity verification Third Party Providers collect your personal data via our Sites through the use
		of Apple Inc.'s (“Apple”) TrueDepth Application Programming Interface (“TrueDepth API”). As a result of the
		integration of our Sites with such Third Party Providers, our Sites make use of automatically collected
		information using the device camera on your Apple mobile device and the TrueDepth API provided by Apple.&nbsp;
	</p>
	<p>The use of your personal data collected as a result of this is to track your facial features, and control the
		augmented reality (AR) experience. We use ARKit to capture your face 3D spatial orientation and facial
		expressions. In doing this, we use this data to ensure that the picture (selfie) being taken is of a live user
		for authentication and fraud reduction purposes. The ARKit information is processed entirely locally and the
		spatial orientation/facial expression data is not submitted to any third (or first) parties. None of the
		information collected by the TrueDepth API ever leaves your mobile device nor is it persistently stored on the
		device.&nbsp;</p>
	<p>We will do our reasonable best to ensure personal data provided by you to us and shared with a Third Party
		Provider is done in accordance with the provisions of Data Protection Laws. We will also reasonably ensure that
		such Third Party Providers with whom we share your personal data will ensure the security of the same as
		provided by this Policy and in accordance with Data Protection Laws.&nbsp;</p>
	<h3>COOKIES</h3>
	<p>Cookies are small text files stored on your device when you visit a website. These files contain information that
		helps enhance your browsing experience by remembering your preferences, enabling functionalities, and providing
		personalised services. The types of cookies we use are:</p>
	<ul>
		<li><b>Necessary Cookies:</b> These are essential for the website to function properly and cannot be disabled.
		</li>
		<li><b>Performance and Analytics Cookies:</b> These cookies help us analyse site performance and improve its
			functionality.</li>
		<li><b>Advertising and Targeting Cookies:</b> These cookies are used to deliver relevant advertisements to you.
		</li>
	</ul>
	<p>We use cookies for various purposes, including:</p>
	<ul>
		<li><b>Personalisation:</b> To provide tailored content and advertisements based on your preferences.</li>
		<li><b>Security:</b> To ensure safe and secure access to our website.</li>
		<li><b>Analytics:</b> To collect data about website traffic and user behaviour for continuous improvement.</li>
		<li><b>Functionality:</b> To remember your preferences and provide a seamless user experience.</li>
	</ul>
	<p>You have the option to manage your cookie preferences. Most web browsers allow you to control cookies through
		their settings. You can:</p>
	<ul>
		<li>Enabling or disabling the cookies.</li>
		<li>Delete cookies stored on your device.</li>
		<li>Adjust browser settings to notify you before accepting cookies.</li>
	</ul>
	<h3>UPDATES TO THE PRIVACY POLICY</h3>
	<p>We are constantly trying to improve our Sites and services, so we may need to change this Policy from time to
		time as well. We will alert you of material changes by, for example, placing a notice on our websites and/or by
		sending you an email (if you have registered your e-mail details with us) when we are required to do so by
		applicable law. We reserve the right to update this Policy as we deem fit, from time to time, without any
		intimation to you and your continued use of the Sites will signify your acceptance of any amendment to these
		terms. &nbsp;</p>
	<p>Our updated terms will also be displayed on our website (www.moniepoint.com/ng) and
		www.atm.moniepoint.com/login/web). It is your responsibility to check this Privacy Policy from time to time to
		verify such updates.</p>
	<p>If you believe at any time that we have not handled your personal data in accordance with this Policy, please
		contact our Data Protection Officer.</p>
	<p>We have appointed a Data Protection Officer (DPO) who is responsible for dealing with all such concerns, in
		addition to overseeing questions relating to this Policy and handling requests in relation to the exercise of
		your rights. If you have any concerns or questions, please contact the Data Protection Officer using the details
		set out below.</p>
	<h3>CONTACT</h3>
	<h3>Data Protection Officer</h3>
	<p>Moniepoint Microfinance Bank Limited</p>
	<p>The Post Square Adeola Odeku Street, Victoria Island, Lagos, Nigeria</p>
	<p><a href="mailto:dpo@teamapt.com">dpo@moniepoint.com</a></p>
	<p>If you have any questions, comments and requests regarding your privacy and rights, please let us know how we can
		help<strong>.</strong></p>
	<p>Last Updated: 2nd December 2024.</p>
</div>